import classNames from 'classnames';
import React from 'react';

import styles from './Button.module.scss';

export interface Props extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode;
}

const CombinedButton = (props: Props) => {
  return (
    <div {...props} className={classNames(styles.combined, props.className)}>
      {props.children}
    </div>
  );
};

CombinedButton.displayName = 'CombinedButton';

export default CombinedButton;
